import React from 'react';
import { Row, Col, Card, Typography } from 'antd';
import { motion } from 'framer-motion';
import { 
  AuditOutlined, 
  SolutionOutlined, 
  SafetyCertificateOutlined, 
  UserSwitchOutlined ,
  UnlockOutlined,
} from '@ant-design/icons';
import './Services.css';

const { Title } = Typography;

const services = [
  {
    title: "Registration Consulting",
    description: "End-to-end support for PHC registration, ensuring all legal and procedural requirements are properly fulfilled.",
    icon: <SafetyCertificateOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
  },
  {
    title: "Provisional licensing",
    description: "Complete guidance for obtaining your PHC provisional license with accurate documentation and compliance support.",
    icon: <SolutionOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
  },
  {
    title: "Regular Licensing",
    description: "We ensure a seamless upgrade to your regular PHC license by managing all compliance and documentation requirements.",
    icon: <AuditOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
  },
  {
    title: "Desealing",
    description: "Expert support in fulfilling PHC conditions and documentation required for the desealing of your healthcare facility.",
    icon: <UnlockOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
  }
];

const Services = () => {
  return (
    <div className="services-section" style={{ padding: '50px 0' }}>
      <Title level={2} style={{ textAlign: 'center', marginBottom: '50px' }}>Our Services</Title>
      <Row gutter={[24, 24]}>
        {services.map((service, index) => (
          <Col xs={24} sm={12} md={6} key={index}>
            <motion.div
              whileHover={{ y: -10 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card 
                hoverable 
                className="service-card"
                actions={[
                  <a href="/services">Learn more</a>
                ]}
              >
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                  {service.icon}
                </div>
                <Card.Meta 
                  title={service.title} 
                  description={service.description}
                />
              </Card>
            </motion.div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Services;